/* SafeStap · bundle selector: the selected offer sets the product form quantity
   and is mirrored on the theme prices (main price, sticky bar, ATC button). */
(function () {
  'use strict';
  if (window.ssBundleLoaded) return;
  window.ssBundleLoaded = true;

  var appliedCode = null;
  var routesRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function applyDiscount(code) {
    if (!code || code === appliedCode || (window.Shopify && window.Shopify.designMode)) return;
    appliedCode = code;
    fetch(routesRoot + 'discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {
      appliedCode = null;
    });
  }

  // Quantity inputs of the same product form, other than the bundle's own hidden input.
  function formQuantityInputs(bundle) {
    var formId = bundle.getAttribute('data-form-id');
    var form = document.getElementById(formId);
    return Array.prototype.filter.call(document.querySelectorAll('input[name="quantity"]'), function (el) {
      if (el.closest('.ss-bundle')) return false;
      return el.getAttribute('form') === formId || (form && form.contains(el));
    });
  }

  function setText(nodes, text) {
    Array.prototype.forEach.call(nodes, function (el) {
      if (el.textContent.trim() !== text) el.textContent = text;
    });
  }

  // Paints an offer on a theme price block (markup of snippets/price.liquid).
  function paintPrice(container, radio) {
    var wrapper = container.querySelector('.price');
    if (!wrapper) return;
    var onSale = radio.getAttribute('data-on-sale') === 'true';
    setText(
      wrapper.querySelectorAll('.price__regular .price-item--regular, .price__sale .price-item--sale'),
      radio.getAttribute('data-price')
    );
    setText(wrapper.querySelectorAll('.price__sale s.price-item--regular'), radio.getAttribute('data-compare'));
    wrapper.classList.toggle('price--on-sale', onSale);
    var badge = wrapper.querySelector('.price__badge-sale .nowrap');
    if (badge && onSale) setText([badge], radio.getAttribute('data-badge'));
  }

  function syncPrices(bundle, radio) {
    if (bundle.getAttribute('data-sync-price') !== 'true') return;
    var sectionId = bundle.getAttribute('data-section-id');
    var observer = bundle.ssObserver;
    if (observer) observer.disconnect();

    var blocks = [];
    ['price-', 'sticky-atc-separate-price-'].forEach(function (prefix) {
      var el = document.getElementById(prefix + sectionId);
      if (!el) return;
      paintPrice(el, radio);
      blocks.push(el);
    });
    ['main-atc-price-', 'sticky-atc-price-'].forEach(function (prefix) {
      setText(document.querySelectorAll('[id="' + prefix + sectionId + '"]'), radio.getAttribute('data-price') + ' •');
    });

    // The theme re-renders prices on variant change: paint the offer again.
    if (!observer) {
      observer = new MutationObserver(function () {
        var current = bundle.querySelector('.ss-bundle__radio:checked');
        if (current) syncPrices(bundle, current);
      });
      bundle.ssObserver = observer;
    }
    blocks.forEach(function (el) {
      observer.observe(el, { childList: true, subtree: true, characterData: true });
    });
  }

  function update(bundle, userAction) {
    var radios = bundle.querySelectorAll('.ss-bundle__radio');
    if (!radios.length) return;
    var current = bundle.querySelector('.ss-bundle__radio:checked') || radios[0];
    current.checked = true;

    var qty = current.value;
    var own = bundle.querySelector('.ss-bundle__qty');
    var others = formQuantityInputs(bundle);
    if (others.length) {
      own.disabled = true;
      others.forEach(function (el) {
        if (el.value === qty) return;
        el.value = qty;
        el.dispatchEvent(new Event('change', { bubbles: true }));
      });
    } else {
      own.disabled = false;
      own.value = qty;
    }

    Array.prototype.forEach.call(bundle.querySelectorAll('.ss-bundle__card'), function (card) {
      card.classList.toggle('is-selected', card.contains(current));
    });

    syncPrices(bundle, current);
    applyDiscount(current.getAttribute('data-discount'));

    if (userAction) {
      bundle.dispatchEvent(new CustomEvent('ss-bundle:change', { bubbles: true, detail: { quantity: Number(qty) } }));
    }
  }

  function init(bundle) {
    if (!bundle.hasAttribute('data-ss-ready')) {
      bundle.setAttribute('data-ss-ready', '');
      bundle.addEventListener('change', function (event) {
        if (event.target.classList && event.target.classList.contains('ss-bundle__radio')) update(bundle, true);
      });
    }
    update(bundle, false);
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('.ss-bundle'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
